import { Helmet } from 'react-helmet-async';

import DealerRequiredPageShell from 'app/components/ReusableUIComponents/HighLevelComponents/DealerRequiredPageShell';
import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import { CONFIGURE_RESOURCE_TEMPLATE_VALUE_PREFERENCES } from 'app/pages/ConfigurePage/utils/configureResourceIds';
import MessageContentTab from 'app/pages/ContentManagementPage/components/messageContent/MessageContentTab';

import { useTemplateValuePreferencesPage } from './hooks/useTemplateValuePreferencesPage';

const TemplateValueConfigurationPage = () => {
  const { breadcrumbsList, hasDealer } = useTemplateValuePreferencesPage();

  return (
    <>
      <Helmet>
        <title>Template Value Preferences</title>
        <meta
          name="description"
          content="Template value preferences configuration page"
        />
      </Helmet>
      <DealerRequiredPageShell
        hasDealer={hasDealer}
        breadcrumbsList={breadcrumbsList}
        pageTitle="Template Value Preferences"
        contentVariant="centered"
        headerSectionMarginTop="64px"
        headerSectionMarginBottom={3}
      >
        <MessageContentTab />
      </DealerRequiredPageShell>
    </>
  );
};

export default withResourceProtection(
  TemplateValueConfigurationPage,
  CONFIGURE_RESOURCE_TEMPLATE_VALUE_PREFERENCES,
);
